// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsFilledSvg from "@ant-design/icons-svg/es/asn/ContactsFilled";
import AntdIcon from '../components/AntdIcon';

var ContactsFilled = function ContactsFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsFilledSvg
  }));
};

ContactsFilled.displayName = 'ContactsFilled';
export default React.forwardRef(ContactsFilled);